import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import { usePlace } from '@/hooks/usePlaces';
import { useFavorites } from '@/hooks/useFavorites';
import { PlaceCard } from '@/components/PlaceCard';
import { PlaceMiniMap } from '@/components/PlaceMiniMap';
import { NotesSection } from '@/components/NotesSection';
import { ChevronRightIcon } from '@/components/Icons';

export function PlaceDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const { place, loading, error } = usePlace(slug);
  const { isFavorite, toggle } = useFavorites();
  const navigate = useNavigate();
  const location = useLocation();
  const fromMap = (location.state as { from?: string } | null)?.from === 'map';

  if (loading) return <div className="skeleton" style={{ height: 300 }} />;
  if (error || !place) {
    return (
      <div className="empty-state">
        <p>We couldn't find that place.</p>
        <Link to="/places" className="btn btn-secondary" style={{ marginTop: 12 }}>
          Back to Places
        </Link>
      </div>
    );
  }

  return (
    <div>
      {/* Real back-navigation, not a hardcoded link to the bare "/places" —
          Places mirrors its filters into the URL, so going back returns to
          whatever filtered view (e.g. In Ranch + Food) the user came from
          instead of resetting it. */}
      <button
        type="button"
        onClick={() => navigate(-1)}
        style={{ display: 'inline-flex', alignItems: 'center', gap: 4, marginBottom: 12, color: 'var(--color-pine)', fontWeight: 700, background: 'none', border: 'none', padding: 0, font: 'inherit', cursor: 'pointer' }}
      >
        <ChevronRightIcon style={{ transform: 'rotate(180deg)' }} />
        {fromMap ? 'Map' : 'Places'}
      </button>
      <PlaceCard place={place} detailed isFavorite={isFavorite(place.id)} onToggleFavorite={toggle} />
      {Number.isFinite(place.latitude) && Number.isFinite(place.longitude) && (
        <PlaceMiniMap
          destinationLat={place.latitude}
          destinationLon={place.longitude}
          destinationLabel={place.name}
        />
      )}
      {place.verification_sources.length > 0 && (
        <div className="card">
          <h2>Verification Sources</h2>
          <ul style={{ paddingLeft: 18, fontSize: 13, color: 'var(--color-ink-muted)' }}>
            {place.verification_sources.map((s) => (
              <li key={s.id}>
                {s.url ? (
                  <a href={s.url} target="_blank" rel="noreferrer">
                    {s.label}
                  </a>
                ) : (
                  s.label
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
      <NotesSection placeId={place.id} />
    </div>
  );
}
